const howToUseData = {
  ja: [
    {
      id: 1000,
      title: '「&wellアプリ」とは',
      content: [
        {
          id: 1001,
          color: '#004098',
          h1: '&wellアプリとは',
          h2: '',
          text: `健康に対しての意識を変え、行動にうつし、健康的な活動を習慣化していただくため、健康に関する様々な情報の提供、イベント・各種プログラムのご案内をするアプリケーションです。`,
          //image: 'movie1.png',
        },
        {
          id: 1002,
          color: 'transparent',
          h1: '&wellウォーク：「チーム対抗戦」とは',
          h2: '',
          text: `歩くことをきっかけに健康に関心を持っていただくことを目的とした、チーム対抗のウォーキングプログラムです。<br>
<ul>
<li>参加企業の中でチームを結成し、チームの平均歩数を競う歩数競争です。</li>
<li>健康づくりで目指したい、8,000歩以上の達成を目指します。</li>
<li>チャットをしながら同僚と励ましあうことで、社内のコミュニケーション活性化にも役立ちます。</li>
<li>上位チームには豪華賞品を進呈します。</li>
<li>開催：年3回</li>
</ul>`,
          //image: 'movie2.png',
        },
        {
          id: 1003,
          color: '#004098',
          h1: '&wellウォーク：「個人チャレンジ」とは',
          h2: '',
          text: `「歩く」ことが日常的な行動が変わっていくことを目的とした、個人単位で参加するウォーキングプログラムです。<br>
<ul>
<li>個人単位で平均歩数を競う歩数競争です。</li>
<li>イベント期間中の個人の平均歩数が一定歩数以上の方に抽選で豪華賞品をプレゼントします。</li>
<li>自分の"推し派"を選び、同じ派の仲間と一緒に楽しみながら歩く、「どっちウォーク」として開催することもあります。</li>
<li>開催：年3回</li>
<li>また、週末2日間限定で気軽に参加できる「WEEKEND Walk」も年3回実施しています。</li>
</ul>
`,
          //image: 'walkthrough_illust22@2x.png',
        },
        {
          id: 1005,
          color: 'transparent',
          h1: '「ウェル知」とは',
          h2: '',
          text: `スキマ時間で、気軽に取り組めるヘルスリテラシークイズです。<br>
<ul>
<li>毎週月曜日に1問公開</li>
<li>&well50※から毎週1テーマをピックアップ。<br>
※&well50とは、健康的な生活を実践するために最低限押さえておきたい50のテーマです。</li>
<li>職場で話題になるような、驚きと気づきのある問題で楽しみながら健康リテラシーを高めていきます。</li>
</ul>`,
          //image: 'movie5.png',
        },
        {
          id: 1020,
          color: 'transparent',
          h1: '「ウェル検」とは',
          h2: '',
          text: `8,000歩/日歩くとチャレンジできるヘルスリテラシークイズです。<br>
<ul>
<li>テーマごとに5問出題され、5問中4問正解すると合格。</li>
<li>解答後には、問題を振り返った上で、達成度やランキングを確認することができます。</li>
</ul>`,
          //image: 'wellken.png',
        },
        {
          id: 1021,
          color: 'transparent',
          h1: '「Column」とは',
          h2: '',
          text: `通勤や休憩時間など、隙間時間にサクッと健康知識が学べるコラムです。<br>
<ul>
<li>各テーマの専門家・第一人者から得た有益な情報だけを厳選してお届け。</li>
<li>食事、運動、睡眠など今知りたい内容が盛りだくさん。ヘルスリテラシーの向上に役立てましょう。</li>
</ul>`,
          image: 'column.webp',
        },
        {
          id: 1022,
          color: 'transparent',
          h1: '「movie」とは',
          h2: '',
          text: `週1回、約5分の動画で気軽にヘルスリテラシーを習得できるプログラムです。<br>
<ul>
<li>毎週月曜日に配信</li>
<li>&well50※から毎週1テーマをピックアップ。食事、運動、睡眠、メンタルヘルス、健康管理など様々な分野の専門家による&wellオリジナルプログラムです。<br>
※&well50とは、健康的な生活を実践するために最低限押さえておきたい50のテーマです。</li>
</ul>`,
          image: 'movie.webp',
        },
        {
          id: 1009,
          color: 'transparent',
          h1: '「ログ機能」とは',
          h2: '',
          text: `日々の生活習慣を可視化し、習慣化するためのツールです。<br>
<br>
・自分ログ<br>
毎日、食事・睡眠・気分のパターン、体重・体脂肪率を記録・可視化することで健康的な生活スタイルを促進します。<br>
<br>
・体重ログ<br>
体重と体脂肪率を記録することができます。<br>
<br>
・食事・運動ログ<br>
朝・昼・夜・間食に分け、食べた量を直感的に0-4段階で摂取カロリーを記録する事ができます。<br>
実施した運動と実施時間により、消費カロリーを記録する事ができます。<br>
身長・体重と、食事・運動ログの結果をもとに、一日のカロリー収支が適切かを確認することができます。`,
          image: 'logs.png',
        },
        {
          id: 1010,
          color: '#AFD1D8',
          h1: '「ミッション」とは',
          h2: '',
          text: `毎月設定されるミッションを達成することで、&wellポイントが獲得できる機能です。<br>
<ul>
<li>ミッションは毎月設定され、ミッションを1つ達成する毎にポイントが獲得でき、更に&wellスタンプが1つ押されます。</li>
<li>多くのミッションを達成して、ポイントをGETしましょう。</li>
</ul>`,
          image: 'mission.png',
        },
        {
          id: 1011,
          color: 'transparent',
          h1: '「&wellポイント」とは（ため方・使い方）',
          h2: '',
          text: `&wellでの健康づくりを、楽しく・モチベーション高く取り組んでいただくための仕組みです。たまったポイントは商品に交換できます。<br>
<br>
・貯める<br>
日々の活動を積み重ね、様々なミッションをクリアするとポイントゲット！<br>
&wellスタンプを10個集めると、&wellスタンプコンプリートボーナスとして別途ポイントを獲得することができます。<br>
<br>
・使う（2通り）<br>
1. いつでもポイントを商品と交換できます。<br>
2. ポイント交換キャンペーン<br>
豪華賞品をゲットできるチャンス？！`,
          //image: 'movie11.png',
        },
        {
          id: 1012,
          color: 'transparent',
          h1: '「疾病リスク予測」とは',
          h2: '',
          text: `自分自身の健康状態を知り、健康への意識の変化・きっかけづくりになるツールです。<br>
<ul>
<li>1年分の健康診断データをもとに、5年後の3疾病（糖尿病・高血圧症・脂質異常症）のリスク（％）を予測</li>
<li>「5年後の発症確率」でリスクを予測</li>
<li>「改善シミュレーション」で目標体重をアドバイス</li>
<li>「生活習慣改善のアドバイス」で、あなたに必要なコンテンツをレコメンド</li>
</ul>`,
          image: 'risk.png',
        },
        {
          id: 1013,
          color: 'transparent',
          h1: '「友だち機能」とは',
          h2: '',
          text: `QRコードや「つながるコード」を利用してアプリ内の友だちになることが可能です。<br>
<ul>
<li>友だちになる方法（3つ）</li>
<ol>
<li>相手のQRコードを、自分のQRコードリーダーでスキャンする</li>
<li>自分のQRコードを、相手のQRコードリーダーでスキャンする</li>
<li>「つながるコード」をSNSやメールで送り、ユーザー検索欄に入力してもらう</li>
</ol>
<li>「友だちになる」ボタンをタップすると「申請中」になります。</li>
<li>リクエストメニューに届いたリクエストを「承認」します。</li>
</ul>
友だちになると以下のことができます。<br>
<ul>
<li>プロフィール情報（所属・ニックネーム）や活動データの閲覧</li>
<li>チャット利用</li>
<li>日々のアクティビティが友だちのタイムラインに表示</li>
</ul>`,
          image: 'friend.png',
        },
        {
          id: 1014,
          color: '#AFD1D8',
          h1: '「目標設定」とは',
          h2: '',
          text: `現在の体重・身長を入力すると、BMI22を元にした適正な体重を表示できます。<br>
<ul>
<li>適正体重を参考に目標体重を入力</li>
<li>目標体重はグラフ上に表示され、視覚的に確認可能</li>
<li>BMIが18.5未満の場合、痩せすぎと判断し実施不可</li>
<li>減量の場合は、現在の体重−2kg以内（1ヵ月あたり）が理想的</li>
</ul>
無理のない目標体重を定めましょう！`,
          image: 'walkthrough_illust29@2x.png',
        },
        {
          id: 1015,
          color: 'transparent',
          h1: 'Fitbitについて',
          h2: '',
          text: `&wellアプリは、Fitbitと連携することで、歩数を自動的に取得することができます。`,
          image: 'fitbit.png',
        },
        {
          id: 1017,
          color: '#838383',
          h1: 'あすけんについて',
          h2: '',
          text: `&wellは、あすけん（食生活記録・改善アプリ）と連携できます。<br>
<br>
・連携できるデータ<br>
<ul>
<li>体重</li>
<li>体脂肪率</li>
<li>摂取エネルギー</li>
<li>消費カロリー</li>
</ul>
※前日の登録分が翌日に反映されます。<br>
取得データは自分ログに表示され、グラフ表示も可能です。<br>
<br>
・連携方法<br>
<ul>
<li>あすけんアカウントをお持ちの方<br>
設定画面→「あすけん連携」→「ログイン」→「データアクセス許諾」</li>
<li>アカウントをお持ちでない方<br>
ストアからあすけんをインストールし、新規会員登録を完了してください。</li>
</ul>`,
          //image: '23.png',
        },
      ],
    },
  ],
  en: [
    {
      id: 1000,
      title: 'What Is the &well App?',
      content: [
        {
          id: 1001,
          color: '#004098',
          h1: 'What Is the &well App?',
          h2: '',
          text: `&well is an app that provides a variety of information about health, events, and programs to help you change your health awareness, put it into action, and make health activities a habit.`,
          //image: 'movie1.png',
        },
        {
          id: 1002,
          color: 'transparent',
          h1: '&well Walk: What are Team Competitions?',
          h2: '',
          text: `A team-based walking program designed to get people interested in health through walking.<br>
<ul>
<li>Employees at participating companies form teams and compete with other teams to walk the most steps on average.</li>
<li>Aim for at least 8,000 steps to get healthier.</li>
<li>Colleagues encourage each other while chatting together, also helping boost communication in the company.</li>
<li>The top-ranking teams receive luxury prizes.</li>
<li>Held: Three times a year.</li>
</ul>`,
          //image: 'movie2.png',
        },
        {
          id: 1003,
          color: '#004098',
          h1: '&well Walk: What are Individual Challenges?',
          h2: '',
          text: `A walking program for individuals designed to make walking change your daily behavior.<br>
<ul>
<li>Individuals compete to walk the most steps on average.</li>
<li>Individuals whose average steps is above a certain number during the event period will be entered in a luxury prize draw.</li>
<li>Sometimes held as "Kutchi Walk," where you choose your favorite team and enjoy walking with teammates.</li>
<li>Held: Three times a year.</li>
</ul>
"WEEKEND Walk," a casual 2-day weekend event, is also held three times a year.`,
          //image: 'walkthrough_illust22@2x.png',
        },
        {
          id: 1005,
          color: 'transparent',
          h1: 'What Is Well-zhi?',
          h2: '',
          text: `An easy-to-do health literacy quiz you can tackle during spare time.<br>
<ul>
<li>One question is released every Monday.</li>
<li>One theme is picked up each week from &well50※.<br>
※&well50 refers to 50 themes you should know to practice a healthy lifestyle.</li>
<li>Raise your health literacy through fun questions with surprises and insights that'll be the talk of your workplace.</li>
</ul>`,
          //image: 'movie5.png',
        },
        {
          id: 1020,
          color: 'transparent',
          h1: 'What Is Well-ken?',
          h2: '',
          text: `A health literacy quiz you can challenge when you walk 8,000 steps per day.<br>
<ul>
<li>5 questions are asked per theme; you pass if you answer 4 out of 5 correctly.</li>
<li>After answering, you can review the questions and check your achievement level and ranking.</li>
</ul>`,
          //image: 'wellken.png',
        },
        {
          id: 1021,
          color: 'transparent',
          h1: 'What Is Column?',
          h2: '',
          text: `A column where you can quickly learn about health during your commute, breaks, or spare time. We carefully select and deliver useful information from experts and leading figures in each theme.<br>
Plenty of content on diet, exercise, sleep, and more. Use it to improve your health literacy.`,
          image: 'column.webp',
        },
        {
          id: 1022,
          color: 'transparent',
          h1: 'What Is Movie?',
          h2: '',
          text: `A program to casually improve your health literacy by watching a video once a week (about 5 minutes).<br>
<ul>
<li>Streamed every Monday.</li>
<li>One theme is picked up each week from &well50※. Original &well programs by experts on diet, exercise, sleep, mental health, health management, and more.<br>
※&well50 refers to 50 themes you should know to practice a healthy lifestyle.</li>
</ul>`,
          image: 'movie.webp',
        },
        {
          id: 1009,
          color: '#AFD1D8',
          h1: 'What Are Log Features?',
          h2: '',
          text: `Tools to visualize your daily lifestyle and make it a habit.<br>
<br>
・Self-Log<br>
Encourages you to lead a healthy lifestyle by recording and graphically showing your eating, sleeping, mood patterns, weight, and body fat percentage every day.<br>
<br>
・Weight Log<br>
Lets you record your weight and body fat percentage.<br>
<br>
・Diet & Exercise Log<br>
Record your intake calories intuitively on a 0-4 scale by meal (breakfast, lunch, dinner, snacks).<br>
Record calories burned based on the exercise you did and how long you did it.<br>
You can check if your daily calorie balance is appropriate based on your height, weight, and diet & exercise log results.`,
          image: 'logs.png',
        },
        {
          id: 1010,
          color: '#AFD1D8',
          h1: 'What Are Missions?',
          h2: '',
          text: `A feature that lets you earn &well points by completing missions set every month.<br>
<ul>
<li>Missions are set every month; for each one you complete, you'll get points and an &well stamp.</li>
<li>Complete as many missions as you can and get points!</li>
</ul>`,
          image: 'mission.png',
        },
        {
          id: 1011,
          color: 'transparent',
          h1: 'What Are &well Points? (How to Earn and Use Them)',
          h2: '',
          text: `A system to make working on your health through &well fun and motivating. Accumulated points can be exchanged for products.<br>
<br>
・Earning points<br>
Get points for keeping up your activities every day and completing a wide variety of missions!<br>
If you collect 10 &well stamps, you'll get additional points as an &well stamp completion bonus.<br>
<br>
・Two ways to use them<br>
1. You can exchange points for products anytime.<br>
2. Point Exchange Campaigns<br>
A chance to win a luxury prize!`,
          //image: 'movie11.png',
        },
        {
          id: 1012,
          color: '#AFD1D8',
          h1: 'What Is Disease Risk Prediction?',
          h2: '',
          text: `A tool to prompt you to change your health awareness and take action based on knowing your own health.<br>
<ul>
<li>Predicts your risk (%) of developing three diseases (diabetes, high blood pressure, dyslipidemia) in the next five years, based on a year's worth of health check data.</li>
<li>Predicts the risk as a probability of onset in the next five years.</li>
<li>Gives advice about your target weight through improvement simulations.</li>
<li>Recommends content you need through lifestyle improvement advice.</li>
</ul>`,
          image: 'walkthrough_illust31@2x.png',
        },
        {
          id: 1013,
          color: '#C8B38D',
          h1: 'What Is the Friends Feature?',
          h2: '',
          text: `You can use QR codes or "Connect Codes" to become friends in the app.<br>
<br>
・Three ways to become friends<br>
1. Scan the other person's QR code with your own QR code reader.<br>
2. Scan your own QR code with the other person's QR code reader.<br>
3. Send your "Connect Code" via SNS or email so they can enter it in the user search field.<br>
<ul>
<li>If you tap the "Become Friends" button, it changes to "Requested."</li>
<li>Accept the request that arrives in your request menu.</li>
</ul>
・Once you become friends<br>
<ul>
<li>View profile information (team, nickname) and activity data</li>
<li>Use chat</li>
<li>Your daily activities are displayed on your friends' timelines</li>
</ul>`,
          image: 'walkthrough_illust7@2x.png',
        },
        {
          id: 1014,
          color: '#AFD1D8',
          h1: 'What Is Goal Setting?',
          h2: '',
          text: `If you enter your current weight and height, you'll be able to see your appropriate weight based on a BMI of 22.<br>
<ul>
<li>Enter your target weight as a guide from your appropriate weight.</li>
<li>Your target weight is displayed on a graph so you can check it visually.</li>
<li>If your BMI is below 18.5, you'll be considered underweight and cannot participate.</li>
<li>For weight loss, not more than 2 kg below your current weight (per month) is ideal.</li>
</ul>
Set a reasonable target weight!`,
          image: 'walkthrough_illust29@2x.png',
        },
        {
          id: 1015,
          color: 'transparent',
          h1: 'About Fitbit',
          h2: '',
          text: `The &well app can automatically acquire your step count by linking with Fitbit.`,
          image: 'fitbit.png',
        },
        {
          id: 1017,
          color: '#838383',
          h1: 'About Asken',
          h2: '',
          text: `&well can be linked with the Asken dietary record/improvement app.<br>
<br>
・Data that can be linked<br>
<ul>
<li>Weight</li>
<li>Body fat percentage</li>
<li>Energy intake</li>
<li>Calories burned</li>
</ul>
Note: The data registered the previous day will be reflected the next day.<br>
Acquired data is displayed in your Self-Log and can also be displayed as a graph.<br>
<br>
・How to link<br>
<ul>
<li>Have an Asken account?<br>
Settings screen → "Link with Asken" → "Login" → "Data access permission"</li>
<li>Don't have an account?<br>
Please install Asken from the store and complete the new member registration.</li>
</ul>`,
          //image: '23.png',
        },
      ],
    },
  ],
}

export default howToUseData
